import { Injectable } from '@angular/core';
import { CanActivate, Router, ActivatedRouteSnapshot, RouterStateSnapshot } from '@angular/router';
import { Observable, of } from 'rxjs';

@Injectable()
export class AuthGuard implements CanActivate {

  constructor(private router: Router) { }

  canActivate(route: ActivatedRouteSnapshot, state: RouterStateSnapshot): Observable<boolean> {
    let refreshToken = localStorage.getItem('refreshToken');
    let userIdToken = localStorage.getItem('matiSuperAdminToken');
    if (refreshToken !== undefined && refreshToken !== null && refreshToken !== ''
      && userIdToken !== undefined && userIdToken !== null && userIdToken !== '') {
      return of(true);
    }
    else {
      this.router.navigate(['/auth/login']);
      return of(false);
    }
  }
}